import { render, staticRenderFns } from "./Conference_room.vue?vue&type=template&id=0a28a5d9"
import script from "./Conference_room.vue?vue&type=script&lang=js"
export * from "./Conference_room.vue?vue&type=script&lang=js"
import style0 from "./Conference_room.vue?vue&type=style&index=0&id=0a28a5d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports